import { FormattedMessage, useIntl } from "react-intl";
import {
  convertBytesToGB,
  formatDate,
  formatNumber,
  ListItem,
  url,
} from "lcm-iot-commons";
import { useNavigate } from "react-router-dom-v5-compat";
import { connectSubscriptionShape } from "../../shapes/connectSubscriptionsShape";

type Props = {
  readonly subscription: connectSubscriptionShape;
};

export function ConnectSubscriptionItem({ subscription }: Props) {
  const intl = useIntl();
  const navigate = useNavigate();

  const {
    clientApplicationName,
    status,
    subscriptionName,
    billedUntil,
    pricingModel,
  } = subscription;

  const apiCallQuota = subscription.apiCallQuota
    ? formatNumber(subscription.apiCallQuota)
    : 0;
  const storageQuota = subscription.storageQuota
    ? formatNumber(convertBytesToGB(subscription.storageQuota))
    : 0;
  const uploadDownloadQuota = (subscription as $TSFixMe).uploadDownloadQuota
    ? formatNumber(
        convertBytesToGB((subscription as $TSFixMe).uploadDownloadQuota),
      )
    : 0;

  const subscriptionStatus = (
    <span>
      <FormattedMessage id="label.status" />:{" "}
      <FormattedMessage id={`enum.subscription_status.${status}`} />{" "}
    </span>
  );

  const statusDetails =
    status !== "payment_required" && status !== "open" ? (
      <FormattedMessage
        id={status === "confirmed" ? "label.renewing_on" : "label.ending_on"}
        values={{ date: formatDate(billedUntil, intl) }}
      />
    ) : null;

  const currentTermDetails = (
    <div>
      {subscriptionStatus}
      {pricingModel === "free" ? (
        <FormattedMessage id="label.free_subscription" />
      ) : (
        statusDetails
      )}
    </div>
  );

  const subscriptionDescription = (
    <>
      <div>
        <FormattedMessage
          id="label.subscription_connect_quota"
          values={{ uploadDownloadQuota, storageQuota, apiCallQuota }}
        />
      </div>
      {currentTermDetails}
    </>
  );

  const handleOnClick = () => {
    if (subscription.status === "open") {
      navigate(url(`/plan_variants/${subscription.id}`));
    } else {
      navigate(url(`/subscriptions/connect/${subscription.id}`));
    }
  };

  return (
    <ListItem
      onClick={handleOnClick}
      id={`connect-subscription-item-${subscription.id}`}
      title={`${clientApplicationName} - ${subscriptionName}`}
      description={subscriptionDescription}
      icon="lcm-iot-icon-connect"
    />
  );
}

export default ConnectSubscriptionItem;
